import { ActionType } from '../constants/ActionTypes'
import { LanguageService } from '../services/LanguageService';

const defaultTranslation = LanguageService.getTranslation(LanguageService.getSelectedLanguage());

const initialState = {
  locale: LanguageService.getSelectedLanguage(),
  messages: defaultTranslation.messages
};

export default function intlReducer(state = initialState, action = {}) {

    switch (action.type) {
    case ActionType.CHANGE_LANGUAGE:
      return {
        ...state,
        locale: action.payload.locale,
        messages: action.payload.messages
      };

    default:
      return state;
  }

}

